module.exports = __webpack_public_path__ + "static/media/speaker_Huawei_DrJiaZen.86c32ba5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_Huawei_DrJiaZen.jpg
// module id = 246
// module chunks = 0